import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { App, createAppRuntime } from './app.tsx';
import { buildMsalConfig, readEntraSettings } from './auth/msal.ts';
import './styles/tokens.css';
import './styles/base.css';

const root = document.getElementById('root');
if (root === null) {
  throw new Error('root element missing from index.html');
}

const entra = readEntraSettings(import.meta.env);
const msal = new PublicClientApplication(buildMsalConfig(entra, window.location.origin));
const runtime = createAppRuntime({ entra });

createRoot(root).render(
  <StrictMode>
    <App runtime={runtime} msal={msal} />
  </StrictMode>,
);
